import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestSparePartsList(data) {
    return fetch.get(
        `${BASE_URL}/api/app/svc-machine-instances/getBomFromMachine/${data.id}`
    );
}